import React, { Fragment } from "react";
import PropTypes from "prop-types";
import SafeHTML from "./SafeHTML";
import style from '../../scss/components/GenericTextArea';
import OverViewIcon from '../../img/list-search.svg'
import OverViewIconBlue from '../../img/list-search-blue.svg'
import scrollToElement from 'scroll-to-element';

import SpecsIcon from '../../img/Layer2.svg'
import ApplicationsIcon from '../../img/clipboard.svg'
import OthersIcon from '../../img/othersicon.svg'
export default class GenericTextArea extends React.Component {
    static propTypes = {
        content: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = { 
            menuOpen: false, 
            navHeight: 0,
            activeIndex: null  // Add this to track active section
        };
        this.productlistRef = React.createRef();
    }
    
    myArray = this.props.content.replace(/(<([^>]+)>)/ig, '').split(",");



    setElementHeight = () => {
        const element = document.querySelector('.navbar'); // Replace with correct selector
        var navbarHeight = 0;
        if (element) {
          const navbarHeight = element.offsetHeight;
          if (navbarHeight) {
            this.setState({ navHeight: navbarHeight });
            this.handleScroll();
 
            window.addEventListener('scroll', this.handleScroll);
        }
        //   console.log("Element height:", height);
          // Use height as needed
        } else {
          console.warn("Element not found, skipping height calculation.");
        }
      };
      


    componentDidMount() {
        // Select all buttons within the .subnav class and add event listeners
        document.querySelectorAll('.subnav button').forEach(button => {
          button.addEventListener('click', this.handleButtonClick);
        });

        var navbarHeight = 0;

        var navbarEl = document.querySelector('.navbar')
        
        // setTimeout(()=>{navbarHeight = navbarEl ? navbarEl.offsetHeight : null},0)
        if(navbarEl){
            navbarHeight = navbarEl.offsetHeight;
        }
         
        
        if (navbarHeight) {
            this.setState({ navHeight: navbarHeight });
            this.handleScroll();

            window.addEventListener('scroll', this.handleScroll);
        }

      }
    
      componentWillUnmount() {
        // Cleanup event listeners to avoid memory leaks
        document.querySelectorAll('.subnav button').forEach(button => {
          button.removeEventListener('click', this.handleButtonClick);
        });

        window.removeEventListener('scroll', this.handleScroll);
      }

      handleScroll = () => {
        const productlist = this.productlistRef.current;
        if (productlist) {
            var navlistTop = productlist.getBoundingClientRect().top;
        }
        let el = document.querySelector('.product-nav-section-category');
        let el1 = document.querySelector('.product-nav-section-inner');
    
        if (el) {
            if (navlistTop <= this.state.navHeight) {
                if (!el.classList.contains('active')) {
                    el.classList.add("active");
                    el1.style.top = `${this.state.navHeight}px`;
                }
            } 
            if (navlistTop > this.state.navHeight) {
                el.classList.remove("active");
            }
        }
    
        const sections = document.querySelectorAll(".post-info-title");
        let currentActiveSection = null;
    
        sections.forEach((current) => {
            const rect = current.getBoundingClientRect();
            
            // Check if the section is within the viewport (adjusted threshold)
            if (rect.top <= 800) {
                currentActiveSection = current;
            }
        });
    
        // Only update active state if we found a section in view
        if (currentActiveSection && currentActiveSection.innerHTML !== undefined) {
            const dataTitle = currentActiveSection.innerHTML
                .replace(/<[^>]*>/g, '')
                .replace(/\s*\(.*?\)/, '')
                .replace('Geometry', '')
                .replace('Geometría', '')
                .trim();
    
            // Clear previous active states
            document.querySelectorAll('.product-nav li a').forEach(item => {
                item.classList.remove('product-nav-active');
            });
    
            // Set active state for current section
            
            const button = document.querySelector(`button[data-title="${dataTitle}"]`);
            if (button) {
                const parentAnchor = button.parentElement?.parentElement;
                if (parentAnchor) {
                    parentAnchor.classList.add('product-nav-active');
                }
            }
        }
    };
    
      handleButtonClick = (event) => {
        // Get the title from the data attribute
        const title = event.target.getAttribute('data-title');
    
        // Find the section containing this title
        const section = [...document.querySelectorAll('.post-info-title')].find(sec =>
          sec.innerHTML.replace(/<[^>]*>/g, '').trim().includes(title.trim())
        );

        let el = document.querySelector('.post-info-title');
        let prodNavEl = document.querySelector('.intersection-visible-wrapper');
        const isMobileDevice = window.innerWidth <= 768;
        if(isMobileDevice){
        scrollToElement(section, {
            offset: -(prodNavEl.scrollHeight + document.querySelector('.product-nav').offsetHeight - 100)
        });}
        else{
            const offsetTop = section.getBoundingClientRect().top + window.scrollY - 250;
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
        
    
        // Scroll to the section if found
        if (section) {
            // alert("section");
        //   section.scrollIntoView({ behavior: 'smooth' });
        // const offsetTop = section.getBoundingClientRect().top - 400;
        // window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }
      };

      handleActiveLink(index) {
        let navItems = document.querySelectorAll(".product-nav li")
        for (let i = 1; i <= navItems.length; ++i) {
            if (i === index + 1) {
                document.querySelector(`.product-nav li:nth-child(${i}) a`).classList.add("product-nav-active");
            } else {
                document.querySelector(`.product-nav li:nth-child(${i}) a`).classList.remove("product-nav-active");
            }
        }
    }

    navLinkClick = (e, index) => {
        this.setState({ menuOpen: false });
        
        // Clear all active classes first
        const allNavItems = document.querySelectorAll('.product-nav li a');
        allNavItems.forEach(item => {
            item.classList.remove('product-nav-active');
        });
    
        // Add active class to clicked item
        var parentElement = e.target.parentElement?.parentElement;
        if (parentElement) {
            parentElement.classList.add('product-nav-active');
        }
    
        // Keep track of active index in state
        this.setState({ activeIndex: index });
    }

    toggleMenu() {
        let isMenuOpen = this.state.menuOpen;
        this.setState({ menuOpen: !isMenuOpen });
    }

    render() {
        let iconMapping = [OverViewIcon,SpecsIcon,ApplicationsIcon,OthersIcon]
        return (
            <>
            
            {(this.myArray[0]==='Subnavigation') && (<div class="subnav">
                
            <div class="intersection-visible-wrapper">
                <section class="product-nav-section-category " ref={this.productlistRef}>
                    <div class="product-nav-section-inner category-sub-nav" style={{top:'40px !important'}}>
                        <div class="container">
                        <div className={"product-nav-wrap" + (this.state.menuOpen ? " open" : "")}>
                                <label onClick={() => this.toggleMenu()} class="product-nav-label">Products</label>
                                <ul class="product-nav">
                                {this.myArray.map((item,index) => {
                                        if (index!=0){
                                        return(<li>
                                            <a id={"cat"+index} style={{display:'flex'}}>
                                                <img className="img-icons" src={iconMapping[index-1]} alt={item?.icon} style={{width:'20px', height: '26px'}}/>
                                                <p><button onClick={(e) => this.navLinkClick(e,index)} style={{backgroundColor:"transparent", border:"none", cursor:"pointer"}} data-title={item.trim()}>{item.trim()}</button></p>
                                            </a></li>);
                                        }
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            </div>)}
            {(this.myArray[0]!='Subnavigation') &&(
                <section className="rich-section">
                    <div className="container">
                        <div className="rich-content">
                            <SafeHTML>{this.props.content}</SafeHTML>
                        </div>
                    </div>
                </section>)}
            </>
        );
    }
}
